// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payments-methods {
  padding: 1.25rem;
  padding-right: 0;
}
@media (max-width: 768px) {
  .payments-methods {
    padding: 1rem;
    padding-right: 0;
  }
}
.payments-methods-body {
  max-height: 17rem;
  overflow: auto;
  display: flex;
  flex-direction: column;
  padding-right: 1.25rem;
}
@media (max-width: 768px) {
  .payments-methods-body {
    padding-right: 1rem;
    margin-top: 1rem;
  }
}
.payments-methods-body::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  background-color: transparent;
}
.payments-methods-body::-webkit-scrollbar-track {
  background-color: transparent;
}
.payments-methods-body::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
}
.payments-methods-body > div {
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.payments-methods-body > div:last-child {
  margin-bottom: 0;
}
.payments-methods-body > div span {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: var(--black9);
}
@media (max-width: 768px) {
  .payments-methods-body > div span {
    font-size: 13px;
    line-height: 16px;
  }
}
.payments-methods-body > div .payments-methods-icon {
  width: 20px;
  height: 20px;
  border-radius: 0.25rem;
  margin-right: 0.75rem;
}
.payments-methods-body > div .payments-methods-icon.free {
  background: var(--black3);
  padding: 3px;
  min-width: 20px;
  width: 20px;
  height: 20px;
  border-radius: 0.25rem;
  margin-right: 0.75rem;
}
.payments-methods-body > div .payments-methods-icon.free svg {
  width: 15px;
  height: 15px;
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/dashboard/sections/payments/index.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;AACF;AACE;EAJF;IAKI,aAAA;IACA,gBAAA;EAEF;AACF;AAAE;EACE,iBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;AAEJ;AAAI;EAPF;IAQI,mBAAA;IACA,gBAAA;EAGJ;AACF;AADI;EACE,mBAAA;EACA,oBAAA;EACA,6BAAA;AAGN;AADM;EACE,6BAAA;AAGR;AAAM;EACE,oCAAA;AAER;AAEI;EACE,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAAN;AAEM;EACE,gBAAA;AAAR;AAGM;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AADR;AAGQ;EARF;IASI,eAAA;IACA,iBAAA;EAAR;AACF;AAGM;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,qBAAA;AADR;AAIM;EACE,yBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,qBAAA;AAFR;AAIQ;EACE,WAAA;EACA,YAAA;AAFV","sourcesContent":[".payments-methods {\n  padding: 1.25rem;\n  padding-right: 0;\n\n  @media (max-width: 768px) {\n    padding: 1rem;\n    padding-right: 0;\n  }\n\n  &-body {\n    max-height: 17rem;\n    overflow: auto;\n    display: flex;\n    flex-direction: column;\n    padding-right: 1.25rem;\n\n    @media (max-width: 768px) {\n      padding-right: 1rem;\n      margin-top: 1rem;\n    }\n\n    &::-webkit-scrollbar {\n      width: 0 !important;\n      height: 0 !important;\n      background-color: transparent;\n\n      &-track {\n        background-color: transparent;\n      }\n\n      &-thumb {\n        background-color: rgba(0, 0, 0, 0.2);\n      }\n    }\n\n    & > div {\n      margin-bottom: 1rem;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n\n      span {\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 17px;\n        color: var(--black9);\n\n        @media (max-width: 768px) {\n          font-size: 13px;\n          line-height: 16px;\n        }\n      }\n\n      .payments-methods-icon {\n        width: 20px;\n        height: 20px;\n        border-radius: .25rem;\n        margin-right: .75rem;\n      }\n\n      .payments-methods-icon.free {\n        background: var(--black3);\n        padding: 3px;\n        min-width: 20px;\n        width: 20px;\n        height: 20px;\n        border-radius: .25rem;\n        margin-right: .75rem;\n\n        svg {\n          width: 15px;\n          height: 15px;\n        }\n      }\n    }\n\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
